/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlobType } from '../../models/blob-type';

export interface ApiOrderInvoicesOrderIdGet$Plain$Params {
  orderId: string;
}

export function apiOrderInvoicesOrderIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiOrderInvoicesOrderIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BlobType>> {
  const rb = new RequestBuilder(rootUrl, apiOrderInvoicesOrderIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('orderId', params.orderId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlobType>;
    })
  );
}

apiOrderInvoicesOrderIdGet$Plain.PATH = '/api/order/invoices/{orderId}';
